import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';
import Iframe from '../iframe';
import { API, FLOW, PAYMODE, TOKEN } from '../../../../common/src/constant';
import CONSTANT, { CACHE } from '../../utils/constants';
import {
  getEncodedQs,
  getKey,
  clientMessage,
  getIframeRequestPayload,
  staticPath,
  handleSaveCardOnSubscription
} from '../../utils/common';
import { postInWindow, openPopUpWindow } from '../../utils/formPost';
import { EVENT, log } from '../../common/logger';
import Renewal from '../subscription/renewal';
import PaymodeOffer from '../offers/paymodeOffer';
import { getApplyPromoBaseRequestObj, isPromoAvailable } from '../../controllers/offers';

class Card extends Component {
  hasValidationError = true;

  constructor(props) {
    super(props);
    const newStyle = `.ptm-card-input:focus{
      border-color:${this.props.AppStyle.themeBackgroundColor};
      caret-color:${this.props.AppStyle.themeBackgroundColor};
    }
    .ptm-card-input:focus ~ .hidden-border{
      background:${this.props.AppStyle.themeBackgroundColor};
    }
    .ptm-card-input,.card-expiry,.card-content{
      border-color:${this.props.AppStyle.borderColor};
      color:${this.props.AppStyle.bodyColor}
    }
    .ptm-check,.ptm-container:hover input ~ .ptm-check{
      border-color:${this.props.AppStyle.bodyColor};
    }
    .ptm-card-input::placeholder,.slash,.ptm-container{
      color:${this.props.AppStyle.bodyColor};
    }
    #mm:focus+span+input+p.hidden-border,#yy:focus+p.hidden-border{
      background:${this.props.AppStyle.themeBackgroundColor};
      border-color:transparent;
    }
    .ptm-msg-red {
      color:${this.props.AppStyle.errorColor}
    }
    .ptm-container input:checked ~ .ptm-check{
      background-color: ${this.props.AppStyle.themeBackgroundColor};
      border-color:${this.props.AppStyle.themeBackgroundColor};
    }`;
    const locale = clientMessage(PAYMODE.CARD.toLowerCase(), this.props.cache);
    const config = { ...this.props.cache.getData(CACHE.MERCHANT_CONFIG) };
    this.state = {
      initializeObject: {
        type: 'INITIALIZE',
        paymode: {
          type: this.props.option.type,
          id: this.props.option.id
        },
        requestPayload: getIframeRequestPayload(this.props.cache, API.BIN),
        // IF FLOW IS DEFERRED PASS THE CARD DETAIL OBJECT
        requestCardDetailsPayload:
          config.flow === FLOW.DEFERRED
            ? getIframeRequestPayload(this.props.cache, API.CARD_DETAILS)
            : {},
        style: newStyle,
        error: locale.error,
        instanceKey: this.props.instanceKey
      }
    };
    this.frame = undefined;
  }

  getApplyPromoBaseRequestPayload() {
    if (!isPromoAvailable(this.props.cache)) {
      return null;
    }

    const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    const customerId = getKey(mConfig, 'emiSubvention.customerId', null);
    const payload = getIframeRequestPayload(this.props.cache, API.APPLY_PROMO);
    payload.requestData.body = {
      ...payload.requestData.body,
      ...getApplyPromoBaseRequestObj(this.props.cache, customerId)
    };

    return payload;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isActive) {
      this.setState(prevState => ({
        initializeObject: {
          ...prevState.initializeObject,
          applyPromoRequestPayload: this.getApplyPromoBaseRequestPayload()
        }
      }));
    }
  }

  submit = () => {
    const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);
    const payload = this.props.cache.getData(CACHE.API).requestPayload(API.PT);
    const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    const orderId = this.props.cache.getData(CACHE.ORDER_ID);
    if (config && config.flow === FLOW.DEFERRED) {
      payload.data.body.orderId = orderId;
      payload.query.orderId = orderId;
    }
    payload.data.body = { ...payload.data.body, ...payload.query };
    const reqData = {
      type: CONSTANT.SUBMIT,
      targetURL: `${payload.url}?${getEncodedQs(payload.query)}`,
      queryParams: payload.query,
      method: payload.method,
      requestData: { ...payload.data },
      paymode: { id: this.props.option.id, type: this.props.option.type },
      guestFlow: tokenData.tokenType !== TOKEN.TXN || false,
      shouldPostOpenWindowEvent: this.hasValidationError
    };

    !this.hasValidationError && openPopUpWindow(this.props.cache);
    this.frame && this.frame.postDataToIframe(reqData);
    log({ eventType: EVENT.CARD_IFRAME_SUBMIT });
  };

  messageHandler = event => {
    if (
      !this.props.cache.getData(CACHE.STORE) ||
      getKey(event, 'data.calledFrom') !== 'card' ||
      getKey(event, 'data.instanceKey') !== this.props.instanceKey
    ) {
      return;
    }
    const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    const notifyMerchant = getKey(mConfig, 'handler.notifyMerchant', undefined);
    if (typeof getKey(event, 'data.type') === 'string') {
      switch (event.data.type) {
        case CONSTANT.PAY_SUCCESS: {
          log({ eventType: EVENT.CARD_EVENT_PAY_SUCCESS });
          this.props.onOverlayValueChange(CONSTANT.PROCESSING);
          const response = getKey(event, 'data.response', undefined);
          /** Direct Bank Changes */
          // const isDirect = getKey(response, 'body.bankForm.pageType', undefined);
          // if (isDirect === 'direct') {
          //   postInWindow(null, this.props.cache, true);
          //   this.props.onOverlayValueChange('');
          //   const bankForm = getKey(response, 'body.bankForm', undefined);
          //   bankForm && this.props.toggleDirectBank(bankForm);
          //   return;
          // }

          const { actionUrl, content } = getKey(response, 'body.bankForm.redirectForm', {});
          response.body.content = content;
          response.body.callbackUrl = actionUrl;
          postInWindow(response, this.props.cache);
          break;
        }
        case CONSTANT.PAY_FAIL: {
          log({ eventType: EVENT.CARD_EVENT_PAY_FAIL });
          const data = event.data.response;
          if (
            getKey(data, 'body.resultInfo.resultStatus') === 'F' &&
            getKey(data, 'body.resultInfo.retry') === false
          ) {
            if (
              getKey(data, 'body.txnInfo.RESPCODE', '') === '1006' ||
              getKey(data, 'body.resultInfo.resultCode', '') === '1006'
            ) {
              this.props.onOverlayValueChange('');
              const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
              this.props.cache.getData(CACHE.STORE).setState({ sessionExpired: true });
              const notifyMerchant = getKey(mConfig, 'handler.notifyMerchant', undefined);
              if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
                notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, data);
              }
            } else {
              if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
                notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, data);
              }
              data.body.content = data.body.txnInfo;
            }
          } else if (
            getKey(data, 'body.resultInfo.resultStatus') === 'F' &&
            getKey(data, 'body.resultInfo.retry') === true
          ) {
            this.props.cache.getData(CACHE.STORE).setState({
              overlayValue: CONSTANT.RETRY,
              retryMessage: getKey(data, 'body.resultInfo.resultMsg')
            });
            //  in case of reyr get fallback token from cache and set current access token
            //  and remove txn token to fetch new txn token
            if (this.props.cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
              const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
              const tokenData = this.props.cache.getData(CACHE.FALLBACK_TOKEN_DATA, {
                token: getKey(mConfig, 'data.token', ''),
                tokenType: TOKEN.ACCESS
              });
              this.props.cache.setData(CACHE.TOKEN_DATA, {
                token: tokenData.token,
                tokenType: tokenData.tokenType
              });
            }
          }
          postInWindow(data, this.props.cache);
          break;
        }
        case CONSTANT.SESSION_EXPIRED: {
          log({ eventType: EVENT.CARD_EVENT_SESSION_EXPIRED });
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, {
              message: 'Session Expired'
            });
          }
          this.props.onOverlayValueChange('');
          this.updateGuestToken();
          postInWindow(getKey(event, 'data.response', {}), this.props.cache);
          break;
        }
        case CONSTANT.TXN_TOKEN_EXPIRED: {
          log({ eventType: EVENT.CARD_EVENT_TXN_TOKEN_EXPIRED });
          this.props.cache.getData(CACHE.STORE).setState({ sessionExpired: true });
          if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, {
              message: 'Session Expired'
            });
          }
          this.props.onOverlayValueChange('');
          postInWindow(getKey(event, 'data.response', {}), this.props.cache);
          break;
        }
        case CONSTANT.CARD_NOT_SUPPORTED: {
          log({ eventType: EVENT.CARD_EVENT_CARD_NOT_SUPPORTED });
          break;
        }
        case CONSTANT.CARD_DETAILS_RESOLVED: {
          log({ eventType: EVENT.CARD_DETAILS_RESOLVED });
          const pcf = getKey(event.data, 'response.pcf');
          if (pcf) {
            this.props.updatePcfAmount(pcf);
          }
          this.props.cache.setData(
            CONSTANT.CARD_TYPE,
            getKey(event.data, 'response.binDetail.paymentMode')
          );
          break;
        }
        case CONSTANT.HELPER_TYPE.CVV_HELPER: {
          log({ eventType: EVENT.CARD_EVENT_CVV_HELPER });
          this.props.onHelperOverlayToggle(CONSTANT.HELPER_TYPE.CVV_HELPER);
          break;
        }
        case 'cardDetails': {
          const obj = {
            details: event.data.cardDetails.details,
            cardHash: event.data.cardDetails.cardHash
          };
          this.props.cache.setData(CACHE.CARD_DETAILS, obj);
          break;
        }
        case CONSTANT.SET_VALIDATION_STATUS: {
          this.hasValidationError = getKey(event, 'data.hasError');
          break;
        }
        case CONSTANT.OPEN_POPUP_WINDOW: {
          const paymodeId = getKey(event, 'data.paymode.id', null);
          const optionId = getKey(this.props, 'option.id', null);
          /* if the paymode id recieved from iframe is same as that of option id then only open the popup */
          if (paymodeId === optionId) {
            openPopUpWindow(this.props.cache);
            log({ eventType: EVENT.POPUP_WINDOW });
          }
          break;
        }
        case CONSTANT.SHOW_PROCESSING: {
          log({ eventType: EVENT.CARD_EVENT_SHOW_PROCESSING });
          this.props.onOverlayValueChange(CONSTANT.PROCESSING);
          break;
        }
        case CONSTANT.HIDE_PROCESSING: {
          log({ eventType: EVENT.CARD_EVENT_HIDE_PROCESSING });
          this.props.onOverlayValueChange('');
          break;
        }
        case CONSTANT.CLIENT_VALIDATION: {
          log({ eventType: EVENT.CARD_EVENT_CLIENT_VALIDATION });
          postInWindow({}, this.props.cache); // close popup window as client side validation failed
          break;
        }
        case CONSTANT.GET_TXN_TOKEN_PAYLOAD: {
          const paymodeId = getKey(event, 'data.paymode.id', null);
          const optionId = getKey(this.props, 'option.id', null);
          if (paymodeId === optionId) {
            this.props.cache
              .getData(CACHE.API)
              .getAsyncPayload(API.PT, this.hasValidationError)
              .then(payload => {
                const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);
                const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
                const orderId = this.props.cache.getData(CACHE.ORDER_ID);
                if (config && config.flow === FLOW.DEFERRED) {
                  payload.data.body.orderId = orderId;
                  payload.query.orderId = orderId;
                }
                payload.data.body = { ...payload.data.body, ...payload.query };
                const reqData = {
                  type: CONSTANT.SUBMIT_WITH_TOKEN,
                  targetURL: `${payload.url}?${getEncodedQs(payload.query)}`,
                  queryParams: payload.query,
                  method: payload.method,
                  requestData: { ...payload.data },
                  paymode: { id: this.props.option.id, type: this.props.option.type },
                  guestFlow: tokenData.tokenType !== TOKEN.TXN || false
                };
                this.frame && this.frame.postDataToIframe(reqData);
              })
              .catch(() => {
                this.props.onOverlayValueChange('');
              });
          }
          break;
        }
        case CONSTANT.UPDATE_HEIGHT: {
          this.updateIframeHeight(event.data.height);
          break;
        }
        case CONSTANT.LOG_CARD_DETAILS: {
          log({ eventType: EVENT.CARD_EVENT_CARD_DETAILS, ...event.data.detail });
          break;
        }
        case CONSTANT.HANDLE_PROMO_RESPONSE: {
          if (event.data.error) {
            this.props.handlePromoErrorFromCard(
              event.data.error,
              event.data.payMethod,
              event.data.bankCode
            );
          } else {
            this.props.handlePromoResponseFromCard(event.data.response, event.data.bankCode);
          }
          break;
        }
        case CONSTANT.CVV_EXPIRY_FOCUS: {
          // const defaultSelectedPaymodeOffSetTop = getKey(
          //   this.props.selected,
          //   'reference._component.componentRef.offsetTop',
          //   0
          // );
          // scrollWithTimeout(defaultSelectedPaymodeOffSetTop + 80);

          break;
        }
        case 'CARD_NUMBER_FOCUS': {
          // const defaultSelectedPaymodeOffSetTop = getKey(
          //   this.props.selected,
          //   'reference._component.componentRef.offsetTop',
          //   0
          // );
          // scrollWithTimeout(defaultSelectedPaymodeOffSetTop);
          break;
        }
        default: {
          break;
        }
      }
    } else if (getKey(event, 'data.hasError')) {
      log({ eventType: EVENT.CARD_ERROR, data: event.data });
      postInWindow({}, this.props.cache);
    }
  };

  updateGuestToken = () => {
    this.props.cache
      .getData(CACHE.API)
      .payModes()
      .then(res => {
        if (getKey(res, 'body.resultInfo.resultStatus', undefined) === 'S') {
          this.props.cache.setData(CACHE.TOKEN_DATA, {
            tokenType: TOKEN.GUEST,
            token: getKey(res, 'body.guestToken', '')
          });
          const { url, query, method, data } = this.props.cache
            .getData(CACHE.API)
            .requestPayload(API.BIN);
          data.body = { ...query };
          const eventData = {
            type: CONSTANT.UPDATE_PAYLOAD,
            paymode: {
              type: this.props.option.type,
              id: this.props.option.id
            },
            requestPayload: {
              targetURL: `${url}?${getEncodedQs(query)}`,
              queryParams: query,
              requestData: data,
              method
            }
          };
          this.frame && this.frame.postDataToIframe(eventData);
        }
      });
  };

  updateIframeHeight = height => {
    const iframe = getKey(this.frame, 'iframe');
    if (iframe) {
      if (height) {
        iframe.style.minHeight = height;
      } else {
        iframe.style.removeProperty('min-height');
      }
    }
  };

  onOptionSelect = option => {
    this.props.onOptionSelect(option);
    this.props.onPayChange(true);
  };

  render({ option, isActive, offers, subscription, instanceKey, cache }, { initializeObject }) {
    const cardOptions = handleSaveCardOnSubscription(
      subscription,
      cache.getData(CACHE.PAYMENT_OPTIONS),
      cache
    );
    const frameData = { ...initializeObject, cardOptions };
    const cardOffer = getKey(offers, PAYMODE.CARD);

    return (
      <div
        className={'ptm-pay-method ptm-w100-ib ptm-noborder'}
        id="checkout-card"
        ref={componentRef => {
          this.componentRef = componentRef;
        }}
      >
        <div className={'ptm-radio-wrap ptm-pt11'}>
          <label className="ptm-lbl">
            <input
              type="radio"
              name={`verify${instanceKey}`}
              className={`ptm-margin0`}
              checked={isActive}
              onClick={() => {
                this.onOptionSelect(option);
              }}
            />
            <span class="ptm-checkmark" />
            <div class={`ptm-pay-method-cont`}>
              <p class={`ptm-paymode-name`}>
                {option && option.showDisplayName ? option.displayName : 'Debit / Credit Cards'}
              </p>
            </div>
          </label>
        </div>
        {option && isActive && (
          <div className={`ptm-card-main`}>
            <Iframe
              ref={r => (this.frame = r)}
              classname={`ptm-card-iframe`}
              name="ptm-card-iframe"
              unload={this.updateIframeHeight}
              postMessageHandler={this.messageHandler}
              src={`${staticPath()}/assets/iframes/card.html`}
              initializeObject={frameData}
            />
            {cardOffer && <PaymodeOffer offer={cardOffer} />}
            <Renewal />
          </div>
        )}
        <p className={`ptm-global-bottom-border`} />
      </div>
    );
  }
}
export default connect(
  'selected, AppStyle, cache, instanceKey, subscription',
  onChange
)(Card);



// WEBPACK FOOTER //
// ./components/card/index.js